import { HttpErrorResponse } from '@angular/common/http';
import {
  CreateTwikeyInviteResponseV1,
  PaymentAccountBurnVerified,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PoaSelectPaymentMethodPadAgreementActions = createActionGroup({
  source: 'POA Select Payment Method Component PAD Agreement',
  events: {
    'Pad Verification Success': props<{
      payload: PaymentAccountBurnVerified[];
    }>(),
    'Pad Verification Error': props<{
      error: HttpErrorResponse;
    }>(),
    'Create Twikey Invite Success': props<{
      payload: CreateTwikeyInviteResponseV1;
    }>(),
    'Create Twikey Invite Error': props<{
      error: HttpErrorResponse;
    }>(),
    'Update Pad Verified Status Success': props<{
      payload: PaymentAccountBurnVerified;
    }>(),
    'Update Pad Verified Status Error': props<{
      error: HttpErrorResponse;
    }>(),
  },
});
